import { render, staticRenderFns } from "./ChallengeTeamForm.vue?vue&type=template&id=55764961&scoped=true"
import script from "./ChallengeTeamForm.vue?vue&type=script&lang=ts"
export * from "./ChallengeTeamForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55764961",
  null
  
)

export default component.exports